import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { getDataById } from './utils';

export function MetadataAddInner({videoId, categoriesArray = []}) {
  const context = useContext(Context);

  const [shown, setShown] = useState(false);

  const getCatData = (id, field) =>  getDataById(context, 'metaDataTypes', id, field);
  const getActive = (id) =>  categoriesArray.includes(id)


  return (
    <div className={`l_addmetadata0`}>


<div className={`l_addmetadata_cont00 ${shown ? 'shown' : ''}`}>
        <div className={`l_addmetadata_cont0 ${shown ? 'shown' : ''}`}>
          <div className="x_meta_tags">


            {context['data']['metaDataTypes'].map(oneCat => (
              <div className="x_meta_tag"
                style={{
                  backgroundColor: getActive(oneCat['id']) ? getCatData(oneCat['id'], 'color') : 'inherit',
                  borderColor: getActive(oneCat['id']) ? getCatData(oneCat['id'], 'color') : 'inherit',
                  color: getActive(oneCat['id']) ? 'white' : 'inherit',
                }}
              >
              <div className="x_meta_icon">
                <div>
                  <div className="p_player_emoji">{getCatData(oneCat['id'], 'emoji')}</div>
                </div>
              </div>
              <div className="x_meta_title">
              {getCatData(oneCat['id'], 'title')}
                <div className="x_meta_title_nums0">
                  <div className="x_meta_title_num">
                    <div>3</div>
                  </div>
                </div>
              </div>
            </div>
            ))}

          </div>
        </div>
      </div>


      <div className={`x_button_container ${shown ? 'shown' : ''}`}>
        <div className="x_button_container_left">
          <div className="x_button x_button--main">
            <div>Add comment</div>
            <div className="x_button_icon">
              <div>comment</div>
            </div>
          </div>


          {shown && <div className="x_button" onClick={()=> setShown(!shown)}>
            <div>Add metadata lane</div>
            <div className="x_button_icon">
              keyboard_arrow_up
            </div>
          </div>}

          {!shown && <div className="x_button active" onClick={()=> setShown(!shown)}>
            <div>Add metadata lane</div>
            <div className="x_button_icon">
              keyboard_arrow_down
            </div>
          </div>}


        </div>
        <div className="x_button_container_right">
          <div className="x_button">
            <div className="x_button_icon">
              <div>settings</div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}


export const MetadataAdd = withRouter(MetadataAddInner);